import { api } from "@/services/api"

// ═══════════════════════════════════════════════════════════════════
//  THE CANCELLATIONS LIST — GET api/ams/cancellations (appointments:manage)
//
//  Mirrors CancellationPage / CancellationListItem in AmsBookingBatchModels.cs.
//  Instants are UTC ISO strings both ways; the page converts to and from
//  Pacific (see app/appointments/cancellations/pacificWindow.ts).
// ═══════════════════════════════════════════════════════════════════

/** Which window the list filters on. Sent by name; the server binds either name or number. */
export type CancellationQueryMode = "CancelledInWindow" | "ScheduledInWindow"

export interface CancellationListItem {
  bookingRequestId: string
  calBookingUid?: string | null
  referenceCode?: string | null
  customerName: string
  originalStart?: string | null
  /** Null for a row cancelled before CMS recorded when. */
  cancelledAt?: string | null
  /** The staff member's UPN, when a staff member cancelled it. */
  cancelledBy?: string | null
  /** AmsBookingActor, as a number — see `BookingActor` in app/appointments/cancellations/canceller.ts. */
  cancelledByActor?: number | null
  /** Why it was cancelled, as recorded with the cancellation. */
  cancellationReason?: string | null
}

export interface CancellationPage {
  items: CancellationListItem[]
  page: number
  pageSize: number
  total: number
}

export interface CancellationQueryArgs {
  /** UTC ISO instant, inclusive. */
  windowStart: string
  /** UTC ISO instant, exclusive. */
  windowEnd: string
  mode: CancellationQueryMode
  /** 1-based. */
  page: number
  /** 1–200. */
  pageSize: number
}

// Tagged with the booking-status tag the cancel and status actions already invalidate, so a
// cancellation made elsewhere in the app shows up here without a manual refresh.
const taggedApi = api.enhanceEndpoints({ addTagTypes: ["AmsBookingStatus"] })

export const cancellationsApi = taggedApi.injectEndpoints({
  endpoints: (builder) => ({
    listCancellations: builder.query<CancellationPage, CancellationQueryArgs>({
      query: (params) => ({ url: "/api/ams/cancellations", params }),
      providesTags: ["AmsBookingStatus"],
    }),
  }),
})

export const { useListCancellationsQuery } = cancellationsApi
